const type = 'SHOW_OTP_CARD_PASSWORD_CHANGE';

const showOtpCardPasswordChange = () => ({
  type,
});

export { type };
export default showOtpCardPasswordChange;
